module.exports = __webpack_public_path__ + "img/Qrcode2.eb2796fc.jpg";